import axios from 'axios';
import * as endpoints from './const';

let cachedSearchString;

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

class UserApi {
  static getAllRestriction(country, companyCode) {
    const api = endpoints.ALL_RESTRICTIONS.replace(':country', country).replace(
      ':companycode',
      companyCode
    );

    return axios
      .get(api)
      .then(response => response.data.data)
      .catch(error => {
        throw error;
      });
  }

  static getUser() {
    return axios
      .get(`${endpoints.USER_PROFILE}`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static updateuser = user => {
    const { firstName, lastName, mobile, userId, zoneId } = user;
    return axios
      .put(`${endpoints.USER_PROFILE}`, {
        firstName,
        lastName,
        mobile,
        userId,
        zoneId
      })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  };

  static getTimeZones = countryCode => {
    const url = endpoints.TIME_ZONES.replace(':country', countryCode);
    return axios
      .get(url)
      .then(response => response.data.data)
      .catch(error => {
        throw error;
      });
  };

  static saveUserRestrictions(userId, payload) {
    return axios
      .post(`${endpoints.USERS}/saverestrictions`, {
        userId,
        companyCodes: payload
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static enableUser(userId, isEnabled) {
    return axios
      .put(`${endpoints.USERS}/${userId}?isEnabled=${isEnabled}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static deleteUser(userId) {
    return axios
      .delete(`${endpoints.USERS}/${userId}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static searchUser(searchString) {
    // TODO - not using searchObj for now, just return all users
    cachedSearchString = `${endpoints.USERS}?userLookup=${searchString}&limit=15`;
    return axios
      .get(cachedSearchString)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }
  static searchUsers(searchObj) {
    const { limit, offset, sort, searchType, searchTerm } = searchObj || {
      limit: 15,
      offset: 0
    };
    cachedSearchString = `${
      endpoints.USERS
    }/search?limit=${limit}&offset=${offset}${sort ? `&sort=${sort}` : ''}`;
    switch (searchType) {
      case 'Username':
        cachedSearchString = `${cachedSearchString}&lookup=${searchTerm}`;
        break;
      case 'Company':
        cachedSearchString = `${cachedSearchString}&CompanyName=${searchTerm}`;
        break;
      case 'Business Unit':
        cachedSearchString = `${cachedSearchString}&BusinessEntity=${searchTerm}`;
        break;
      case 'Role':
        cachedSearchString = `${cachedSearchString}&roleName=${searchTerm}`;
        break;
      default:
        break;
    }
    return axios
      .get(cachedSearchString)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static loadMoreUsers(paging) {
    const { offset, limit, sort } = paging;
    return axios
      .get(`${cachedSearchString}&offset=${offset}&sort=${sort}`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getUsers(searchObj) {
    const { limit, offset } = searchObj || { limit: 15, offset: 0 };
    // TODO - not using searchObj for now, just return all users
    cachedSearchString = `${endpoints.USERS}?limit=${limit}&offset=${offset}`;
    return axios
      .get(cachedSearchString)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getBusinessEntities() {
    return axios
      .get(endpoints.BUSINESS_ENTITIES)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getRoles(businessEntityId) {
    return axios
      .get(`${endpoints.ROLES}?businessEntityId=${businessEntityId}`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getEmployer(businessEntityId, searchText) {
    return axios
      .get(
        `${
          endpoints.BUSINESS_ENTITIES
        }/${businessEntityId}/employers?companyCodeLookup=${encodeURIComponent(
          searchText
        ) || ''}`
      )
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getCostCenters(businessEntityId, countryCode, lookup) {
    return axios
      .get(
        `${
          endpoints.BUSINESS_ENTITIES
        }/getCostCenters/${businessEntityId}/${countryCode}?lookup=${lookup ||
          ''}`
      )
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static generateUserPayload = function(employer) {
    const userId = employer.userId;
    const username = employer.userName;
    const firstName = employer.firstName;
    const lastName = employer.lastName;
    const mobile = employer.mobile;

    const countryId = employer.countryId;
    const businessEntityId = employer.businessEntityId;
    const employerCompanyCode = employer.employerCompanyCode;
    const employerCompanyName = employer.employerCompanyName;
    const active = employer.active;
    const sendWelcomeEmail = employer.SendWelcomeEmail;
    const roles = employer.roles.map(role => role.id);
    // const costCenters = employer.costCenters.map(costCenter => costCenter.code);
    const costCentersAU = employer.costCentersAU ? employer.costCentersAU : {};
    const costCentersNZ = employer.costCentersNZ ? employer.costCentersNZ : {};
    const costCenters = [...costCentersAU, ...costCentersNZ].map(costCenter => {
      const { CompanyCode, CompanyName, countryId } = costCenter;
      return { code: CompanyCode, name: CompanyName, countryId };
    }); // pass in both code & name as per muhammad's request .map(costCenter => costCenter.code);

    return {
      userId,
      username,
      firstName,
      lastName,
      mobile,
      countryId,
      businessEntityId,
      employerCompanyCode,
      employerCompanyName,
      active,
      sendWelcomeEmail,
      roles,
      costCenters
    };
  };

  /**
   * update or create new user
   */
  static updateOrCreateUser(employer) {
    let apiMethod;

    // use post method if this is a new user, eg. userId not exist
    if (!employer.userId) {
      apiMethod = axios.post;
    } else {
      apiMethod = axios.put;
    }

    const payload = this.generateUserPayload(employer);

    return apiMethod(endpoints.USERS, payload)
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors
        };
      })
      .catch(error => {
        throw error;
      });
  }
  /**
   * update  user
   */
  static updateUser(user) {
    const payload = {
      userId: user.userId,
      userName: user.userName,
      firstName: user.firstName,
      lastName: user.lastName,
      mobile: user.mobile,
      businessEntityId: user.businessEntityId,
      countryCode: user.countryCode,
      employerCompanyCode: user.employerCompanyCode,
      employerCompanyName: user.employerCompanyName,
      isActive: user.isActive,
      zoneId: user.zoneId,
      userCompanyCodes: user.userCompanyCodes.map(x => ({
        companyCode: x.companyCode,
        countryCode: x.countryCode,
        restrictions: []
      })),
      roles: user.roles.map(x => x.id),
      userClaims: user.usersClaims
    };
    const resultUser = {
      ...user,
      roles: user.roles.map(x => ({ Id: x.id, Name: x.name }))
    };
    return axios
      .put(endpoints.USERS, payload)
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors,
          user: resultUser
        };
      })
      .catch(error => {
        throw error;
      });
  }
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/UserApi.js